export default __webpack_public_path__ + "static/media/light-map-image.2b99d492.PNG";